import { Component, OnInit, Renderer2 } from '@angular/core';
import { Message, SelectItem } from 'primeng/api';
import { EmpresaRequest } from 'src/app/admihair/api/dto/empresa-request';
import { Municipio } from 'src/app/admihair/api/dto/municipio';
import { Uf } from 'src/app/admihair/api/dto/uf';
import { EmpresaService } from 'src/app/admihair/service/empresa.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { MunicipioService } from 'src/app/admihair/service/municipio.service';
import { UfService } from 'src/app/admihair/service/uf.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { ImagemLogoService } from 'src/app/admihair/service/imagem-logo.service';
import { ImagemLogo } from 'src/app/admihair/api/dto/imagem-logo';


@Component({
  selector: 'app-dados-empresa-detalhar',
  templateUrl: './dados-empresa-detalhar.component.html',
  styleUrls: ['./dados-empresa-detalhar.component.scss']
})
export class DadosEmpresaDetalharComponent implements OnInit {
  
  permissaoDetalhar: boolean = false;
  id?: number;
  progressoRequisicao: boolean = false;
  loading: boolean = false;
  idEmpresa?: number;
  empresa?: EmpresaRequest;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  editar: boolean = false;

  listaUfs: SelectItem[] = [];
  listaMunicipios: SelectItem[] = [];

  crts: SelectItem[] = [
    { label: 'SIMPLES NACIONAL', value: 'SIMPLES_NACIONAL' },
    { label: 'SN - EXCESSO SUBLIMITE', value: 'SN_EXCESSO_SUBLIMITE' },
    { label: 'REGIME NORMAL', value: 'REGIME_NORMAL' }
  ];
  crtSelecionado?: string;


  imageChangedEvent: any = '';
  croppedImage: any = '';
  defaultImage: string = 'assets/demo/images/avatar/logo_default.jpg';
  mostrarDialogImagem: boolean = false;

  constructor(private empresaService: EmpresaService,
    private municipioService: MunicipioService,
    private ufService: UfService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService,
    private renderer: Renderer2,
    private imagemLogoService: ImagemLogoService) { }



  ngOnInit(): void {
    this.loading = true;
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_ADICIONAIS_E_DESCONTOS');
    this.id = this.utilStorageService.getEmpresa().id;
    
    if (this.permissaoDetalhar) {
      this.carregarUfs();
  
      if (!this.croppedImage) {
        this.croppedImage = this.defaultImage;
      }
    }
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.mostrarDialogImagem = true;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  carregarUfs() {
    this.ufService.listarUf().subscribe({
      next: (data: Uf[]) => {
        this.listaUfs = data.map(uf => ({ label: uf.siglaUf, value: uf.codigoUf }));
        this.buscarEmpresa();
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    }
    )
  }

  salvarImagemLogo() {
    const logo: ImagemLogo = {
      usuarioId: this.utilStorageService.getUser().usuario?.id,
      logo: this.croppedImage
    }
    
    this.imagemLogoService.salvar(logo).subscribe({
      next: (data: ImagemLogo) => {
        console.log(data)
        this.buscarEmpresa();
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    });
  }

  buscarImagemLogo() {
        
    this.imagemLogoService.buscarPorId(1).subscribe({
      next: (data: ImagemLogo) => {
        console.log(data)
        this.croppedImage = data.logo;

      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    });
  }

  buscarEmpresa() {
    this.empresaService.buscarDadosEmpresa(this.id).subscribe({
      next: (data: EmpresaRequest) => {
        this.empresa = data;
        this.carregarMunicipios();
        this.buscarImagemLogo();
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela()
      }
    })
  }

  carregarMunicipios(mudarUf?: boolean) {
    const codigoUf = this.listaUfs.find(uf => uf.label === this.empresa?.uf)?.value;
    if (mudarUf && this.empresa?.cidade) {
      this.empresa.cidade = undefined;
    }
    this.municipioService.listarMuniciosPorUf(codigoUf).subscribe({
      next: (data: Municipio[]) => {
        this.listaMunicipios = data.map(m => ({ label: m.descricao, value: m.codigoIbge }));
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    }
    )

  }



  editarDados() {
    this.editar = true;
    this.renderer.selectRootElement('#campoEmail').focus();
    this.carregarUfs();
  }



  atualizar() {
    this.progressoRequisicao = true;
    this.empresaService.atualizarDados(this.empresa).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela()
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela()
      }
    });

  }




  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }
}
